/**
 * Vangnet voor fouten in de schermen.
 *
 * Zonder dit vangnet levert een fout tijdens het tekenen een wit scherm op, en dan
 * is er niets om op af te gaan. Nu staat er wat er misging, met de knop om het
 * opnieuw te proberen.
 */
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  fout: Error | null;
  waar: string | null;
}

export class Foutgrens extends Component<Props, State> {
  state: State = { fout: null, waar: null };

  static getDerivedStateFromError(fout: Error): Partial<State> {
    return { fout };
  }

  componentDidCatch(fout: Error, info: ErrorInfo): void {
    // Zichtbaar in de browserconsole en in Application Insights.
    console.error('Houtstaat — fout tijdens het tekenen van het scherm', fout, info.componentStack);
    this.setState({ waar: info.componentStack ?? null });
  }

  render(): ReactNode {
    const { fout, waar } = this.state;
    if (!fout) return this.props.children;

    return (
      <div style={{ padding: 32, maxWidth: 820, fontFamily: 'Barlow, system-ui, sans-serif' }}>
        <h1 style={{ fontSize: 22, marginBottom: 8 }}>Er ging iets mis in dit scherm</h1>
        <p style={{ color: '#4b5563' }}>
          De rest van de applicatie werkt nog. Probeer het opnieuw; blijft het misgaan, stuur dan de tekst
          hieronder door.
        </p>
        <pre
          style={{
            background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: 8,
            padding: 14,
            fontSize: 12.5,
            whiteSpace: 'pre-wrap',
            color: '#c22a2a',
          }}
        >
          {fout.message}
          {waar ? `\n${waar}` : ''}
        </pre>
        <button
          className="knop primair"
          onClick={() => {
            this.setState({ fout: null, waar: null });
            window.location.hash = '#/houtstaat';
          }}
        >
          Opnieuw proberen
        </button>
      </div>
    );
  }
}
